<template>
	<div class="lesezeichen">
		<v-tooltip bottom>
			<template v-slot:activator="{ on, attrs }">
				<span v-bind="attrs" v-on="on">
					<v-checkbox
						v-if="teilnehmer!=''"
						v-model="lesezeichen"
						color="red"
						off-icon="mdi-bookmark-outline"
						on-icon="mdi-bookmark"
						@click="lesezeichenAendern()"
					>
					</v-checkbox>
				</span>
			</template>
			<span>Lesezeichen anlegen bzw. l&ouml;schen</span>
		</v-tooltip>
	</div>
</template>
<script>
	import axios from 'axios';
	export default {
		name: 'Lesezeichen',
		props: {
			verfahrenid: {
				type: String,
				required: true
			}
		},
		data: function() {
			return {
				lesezeichen: Boolean
			}
		},
		mounted() {
			// Bei Öffnen der Verfahrensdetails wird nachgesehen, ob für das Verfahren ein Lesezeichen gesetzt ist
			this.lesezeichenNachschlagen();
		},
		methods: {
			// In der Lesezeichenliste nachsehen, ob das aktuelle Verfahren enthalten ist.
			lesezeichenNachschlagen: function() {
				axios.get('https://www.arbeitsverdichtung.de/api/lesezeichen', {
					params: {
						teilnehmer: this.teilnehmer,
						verfahrenid: this.verfahrenid
					}
				})
				.then(response => {
					console.log(response);
					if (response.data == 1) {
						this.lesezeichen = true;
					} else {
						this.lesezeichen = false;
					}

				})
				.catch(error => {
					console.log(error);
				});
			},
			// Lesezeichen setzen
			lesezeichenAendern: function() {
				console.log(this.lesezeichen);
				axios.post('https://www.arbeitsverdichtung.de/api/lesezeichen', {
					teilnehmer: this.teilnehmer,
					verfahrenid: this.verfahrenid,
					lesezeichen: this.lesezeichen
				})
				.then(response => {
					console.log(response);
					// Bei erfolgreichern Ausführung wird die Lesezeichenliste im Store neu abgerufen.
					this.$store.dispatch('getLesezeichenListe');
				})
				.catch(error => {
					console.log(error);
				});
			}
		},
		computed: {
			teilnehmer() {
				return this.$store.state.teilnehmer;
			},
			lesezeichenListe() {
				return this.$store.state.lesezeichenListe;
			}
		}
	}
</script>
<style scoped>
</style>
